<span *ngIf="error !== null && (authError$ | async) === error" class="zef-text-p1 auth-error-text">
  <ng-content></ng-content>
</span>
